import { ComponentProps, ReactElement } from 'react';

import { RunPreviewInvoiceResponse } from '@/models/gen/graphql';
import SkyhopPdfFooter from '@/features/PdfLayout/components/SkyhopPdfFooter';
import { usePdfLayout } from '@/features/PdfLayout';

export type InvoicePdfFooterWebProps = ComponentProps<'ul'>;

const InvoicePdfFooterWeb = ({ ...props }: InvoicePdfFooterWebProps): ReactElement => {
  const { website, email } = usePdfLayout(({ state }: { state: { data: RunPreviewInvoiceResponse } }) => ({
    // Company
    website: state?.data?.output?.company?.website,
    email: state?.data?.output?.company?.invoiceEmail,
  }));

  return (
    <SkyhopPdfFooter.Section {...props}>
      {(website || email) && <SkyhopPdfFooter.SectionHeader>Web</SkyhopPdfFooter.SectionHeader>}
      {website && <SkyhopPdfFooter.Item>{website}</SkyhopPdfFooter.Item>}
      {email && <SkyhopPdfFooter.Item>{email}</SkyhopPdfFooter.Item>}
    </SkyhopPdfFooter.Section>
  );
};

export default InvoicePdfFooterWeb;
